<template>
  <div>
    <p class="border-bottom pb-3">
      <b>{{ $t('text.welcome') }}</b>
      {{ $t('page-info.home') }}
    </p>
    <div class="d-flex justify-content-between flex-row flex-md-column border-bottom mb-3">
      <div v-for="(primaryCategory, index) in $root.categories" :key="'nav-' + primaryCategory[0]">
        <h5 :class="{ 'text-right': index === 1 }" class="text-md-center">
          {{ $t('category.' + primaryCategory[0] + '._') }}
        </h5>
        <b-nav pills class="mb-2 flex-column flex-md-row justify-content-md-center"
               :class="{ 'align-items-end': index === 1 }">
          <b-nav-item :href="'#' + category"
                      :class="{ 'text-right': index === 1 }" class="mx-n3 mx-md-0"
                      v-for="category in primaryCategory[1]" :key="'nav-' + category">
            {{ $t('category.' + primaryCategory[0] + '.' + category) }}
          </b-nav-item>
        </b-nav>
      </div>
    </div>
    <div v-for="primaryCategory in $root.categories" :key="primaryCategory[0]">
      <h2>
        {{ $t('category.' + primaryCategory[0] + '._') }}
      </h2>
      <section v-for="category in primaryCategory[1]" :key="category">
        <h3 :id="category">
          {{ $t('category.' + primaryCategory[0] + '.' + category) }}
        </h3>
        <b-form-row v-for="enabled in [true, false]" :key="enabled">
          <b-col class="mb-4"
                 lg="3" md="4" sm="6" cols="6"
                 v-for="tool in tools(category, enabled)" :key="tool.model">
            <ToolCard :tool="tool" :enabled="enabled" :show-price="adtractionPreloaded && enabled" />
          </b-col>
        </b-form-row>
      </section>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ToolCard from '@/components/ToolCard'
import Adtraction from '@/util'

export default {
  name: 'Home',
  components: { ToolCard },
  data () {
    return {
      adtractionPreloaded: false
    }
  },
  methods: {
    ...mapMutations(['toggleModelOwned']),
    isOwned (tool) {
      return this.$store.state.ownedModels.includes(tool.model)
    },
    visit (tool) {
      this.$router.push({ name: 'product', params: { model: tool.model } })
    },
    tools (category, enabled) {
      const region = this.$store.state.currentRegion
      return Object.values(this.$root.tools).filter(e =>
              e.category === category && (region in e.url) === enabled
      )
    }
  },
  async mounted () {
    await Adtraction.preload(
            Object.values(this.$root.tools)
                    .filter(t => this.$store.state.currentRegion in t.url)
                    .map(t => t.model)
    )
    this.adtractionPreloaded = true
  },
  metaInfo () {
    return {
      title: this.$t('menu.page.home'),
      meta: [
        { name: 'description', content: this.$t('app.description') }
      ]
    }
  }
}
</script>

<style lang="scss">
  h1, h2, h3 {
    width: 100%;
    text-align: center;
  }
</style>